import script from "./VideoCourseComp.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCourseComp.vue?vue&type=script&setup=true&lang=js"

import "./VideoCourseComp.vue?vue&type=style&index=0&id=0bffde3b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bffde3b"]])

export default __exports__